const isDevelopment = process.env.NODE_ENV === 'development';
const CLIENT_ID = isDevelopment ? process.env.REACT_APP_OKTA_CLIENT_ID : window.config.clientid;
const ISSUER = isDevelopment ? process.env.REACT_APP_OKTA_ISSUER : window.config.issuer;
const BASENAME = isDevelopment ? process.env.REACT_APP_OKTA_PUBLIC_URL : window.config.url;
const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK === 'true';
const REDIRECT_URI = `${window.location.origin}/implicit/callback`;

export const oktaConfig = {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  app: {
    basename: BASENAME,
  },
};
